import { getCurrentLocale, isDefaultLocale } from "./language-helpers";

declare global {
  interface Window {
    siteVariant?: {
      pathSegment?: string;
    };
  }
  const PAYBIS_ICONS_BASE_URL: string;
}

function isServerSideRendering(): boolean {
  return typeof document === 'undefined';
}

const getBaseUrl = (currentLanguage = getCurrentLocale()): string => {
  const languageSection = isDefaultLocale(currentLanguage) ? '' : '/' + currentLanguage;
  const siteVariantSection = !isServerSideRendering() && window.siteVariant?.pathSegment ? '/' + window.siteVariant.pathSegment : '';

  return siteVariantSection + languageSection;
};

const isDefaultBuyLink = (uri: string): boolean => {
  if (isServerSideRendering()) {
    return false;
  }
  const metaElement = document.querySelector('meta[name="default-link"]') as HTMLMetaElement | null;
  const defaultBuyLink = metaElement?.content;

  if (!defaultBuyLink) {
    return false;
  }

  return uri === `/${defaultBuyLink}/`;
};

const SKIP_SITE_VARIANTS_PAGES: RegExp[] = [
  /^\/member\//,
];
const shouldSkipSiteVariant = (uri: string) => {
  return SKIP_SITE_VARIANTS_PAGES.some(pagePattern => pagePattern.test(uri)) && window?.siteVariant?.pathSegment === 'uk';
};

export default {
  generate(uri: string, params: Record<string, string> = {}, locale?: string): string {
    const base = shouldSkipSiteVariant(uri) ? '' : getBaseUrl(locale);
    const path = isDefaultBuyLink(uri) ? '/' : uri;

    let url = base + path;
    if (typeof params === 'object' && Object.keys(params).length > 0) {
      url =
        url +
        '?' +
        Object.keys(params)
          .map(
            key =>
              encodeURIComponent(key) + '=' + encodeURIComponent(params[key]),
          )
          .join('&');
    }

    return url;
  },

  getMoneyServiceIconByName(iconName: string): string {
    return `${PAYBIS_ICONS_BASE_URL}/default/money-services/${iconName}.svg`;
  },

  //TODO: clean up, if not used anymore
  getMoneyServiceIconPath(filename: string): string {
    return `/images/money-services/${filename}`;
  },
};
